module.exports = __webpack_public_path__ + "static/sailing-28ac54285141b8ea240fd5b67e41f203.mp4";